import React, { useEffect, useMemo, useState } from 'react';
import { Alert } from '@mui/material';
import { Box } from '@mui/system';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import TotalAmountLabels from './Components/TotalAmountLabels';
import EntryTable from './Components/EntryTable';
import { showErrorSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { showSuccessSnackbar } from '../../components/snackBar/snakbar';
import MultiFileAttachment from './Components/MultiFileAttachment';
import Description from './Components/Description';
import Grid from '@mui/material/Grid';
import { deleteTransactionMaster } from '../../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';
import HsnandJournalTab from './Components/HsnandJournalTab';
import {
  createInvoicePOSDetails,
  createPhoneContacts,
  createPOSParty,
  createSalesPosInvoiceTemp,
  createTransactionWithSpecificTime,
  getInvoiceMasterCustom,
  getMinMaxInvoiceDate,
} from '../../graphql';
import './Components//Invoice.css';
import Loader from './Components/Loader';
import { PosPrint } from '../../library/InvoicePrint';
import { ShareModal, useShare } from '../../components/modals/Share';
import printJS from 'print-js';
import ConfirmCancel from '../../components/modals/confirmCancel';
import axios from 'axios';
import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import { uploadToServer } from '../../library/upload';
import PromptInvoiceSettings from '../../components/modals/PromptInvoiceSettings';
import InvoicePosBasicDetails from './Components/InvoicePosBasicDetails';
import ConfirmExit from '../../components/modals/ConfirmExit';
import DraggableAction from '../../components/Buttons/DraggableAction';
import InvoiceCancel from '../../components/modals/InvoiceCancel';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import { useListGeneralSettingQuery, VoucherSettingsApi } from '../../redux/apis/newVoucherSettings.api';
import { useListInvoiceSettingsQuery } from '../../redux/apis/invoiceSettingsApi.api';
import { createPosBatch } from '../../graphql/postgress_graphql/customMutations';
import { useStateList } from './Components/HandleInvoiceStateProvider';
import UseVoucherDetails from './Components/UseVoucherDetails';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';
import PosPaymentDetails from './Components/PosPaymentDetails';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import moment from 'moment';
import API_ENDPOINTS from '../../apiEndpoints';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import CancelUI from '../../components/Ui/CancelUI';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import { fetchAndPrintPDF } from '../../utils/common';
import { CheckVoucherValid } from './Components/CheckVoucherValid';
import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;

function NewPOSPrime({ isVoucher }) {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigate = useControlledNavigation();
  let location = useLocation();
  const { getVoucherDetails } = UseVoucherDetails();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
    const companyPlaceCode = getCompany?.relatedaddressentity?.[0]?.statecode
  const [createPdf, progress] = useCreatePdfMutation();
  const {
    initialState,
    setInitialState,
    data,
    setData,
    cancelModal,
    setCancelModal,
    state,
    setState,
    cancelModalStatus,
    setCancelModalStatus,
    itemData,
    setItemData,
    deleteModalStatus,
    setDeleteModalStatus,
    viewMode,
    setViewMode,
    invoiceEntry,
    setInvoiceEntry,
    totTaxAmt,
    totDiscount,
    totGSTCess,
    totNetAmt,
    totGST,
    totAmt,
    companyState,
    netAmountToPay,
    companyData,
    invTransArr,
    paymentTransArr,
    itemsRows,
    initialAttachments,
    transGeneralSettingsFlag,
    partyAccountID,
    linkedTransArr,
    voucherArr,
    paymentTransID,
    backdropOpen,
    setBackdropOpen,
    setLastInvoiceDate,
    setPosition,
    isDragging,
    setIsDragging,
    offset,
    registrationType,
    setTabValue,
    setItemValid,
    tableErrArr,
    setTableErrArr,
    items,
    setItems,
    setNonItems,
    initItemTableDta,
    previewSalesTaxableModal,
    setPreviewSalesTaxableModal,
    setATags,
    deletedItems,
    currentDouments,
    resetData,
    resetItems,
    resetNonItems,
    setItemsRows,
    setFirstInvoiceDate,
    setNextInvoiceDate,
    firstInvoiceDate,
    lastInvoiceDate,
    nextInvoiceDate,
    generalSettingsFlag
  } = useStateList();
  const { data: companyPreference } = useListCompanyPreferenceQuery();
  const params = location.state || {
    id: parseInt(new URLSearchParams(window.location.search).get('transaction')),
    view: parseInt(new URLSearchParams(window.location.search).get('transaction')) ? true : false,
  };
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  const postingDatePref = companyPreference?.find(
      (p) => p.attributetypecd === 'MyPostingDate' && String(p?.additionalvalue ?? '') === String(userPreferece?.financialYear?.financialyearid ?? '')
    );
        const currentPostingDate = postingDatePref?.attributevalue;
        const [savedPostingDate,setSavedPostingDate]=useState("");
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}`;
  let url = path + `/Invoices/Pos/Ledgerx_Pos_Invoice_${data.voucherNumber}.pdf`;
  let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;
  const [shareOpen, setShareOpen] = useState(false);
  
  // Email sending states
  const [selected, setSelected] = useState([]);

  const { data: generalSettings } = useListGeneralSettingQuery(
    {
      entrytypecd: 'PosInvoice',
      financialyearid: userPreferece?.financialYear?.financialyearid,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;
  const newItemObj = {
    itemCode: { label: '', value: '' },
    name: { label: '', value: '' },
    priceType: { label: '', value: '' },
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    qty: 0,
    units: '',
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
    GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: '0000',
    editable: true,
    new: true,
  };
  dispatch(display());

  const { Enable_CreditPeriod, Enable_ItemWiseEntry } = useSelector((state) => state.paymentSettingsReducer);
  // const InvoiceSettings = useSelector(
  //   (state) => state.invoiceSettingsReducer
  // )?.Pos;
  const {
    data: InvoiceSettingsList,
    isLoading: InvoiceSettingsListLoading,
    isError: InvoiceSettingsListError,
    isFetching: InvoiceFetching,
    // refetch
  } = useListInvoiceSettingsQuery(
    { type: 'ALL' },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const InvoiceSettings = useMemo(() => {
    if (!InvoiceSettingsList) return [];
    return InvoiceSettingsList.find((e) => e.typecd == 'PosSettings');
  }, [InvoiceSettingsList]);

  const endDrag = () => setIsDragging(false);
  useEffect(() => {
    const onDrag = (e) => {
      if (!isDragging) return;
      let newY = e.clientY - offset.y;
      let newX = e.clientX - offset.x;
      newY = Math.max(300, newY);
      newY = Math.min(640, newY);
      newX = Math.max(100, newX);
      newX = Math.min(1445, newX);
      setPosition((prevPosition) => ({
        ...prevPosition,
        y: newY,
        x: newX,
      }));
    };

    if (isDragging) {
      window.addEventListener('mousemove', onDrag);
      window.addEventListener('mouseup', endDrag);
      return () => {
        window.removeEventListener('mousemove', onDrag);
        window.removeEventListener('mouseup', endDrag);
      };
    }
  }, [isDragging, offset.x, offset.y]);

  const [reNavigate, setReNavigate] = useState('');
  let [modalOpen, setModalOpen] = useState(false);
  let saveV = true;
  function deepEqual(obj1, obj2) {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return obj1 === obj2;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);

  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName('a').length);
      }, 50);
    }
  }, [selectorDrawer, selector]);

  const handleNavigationBlocker = (value) => {
    dispatch(setNavigationBlocked(value));
  };

  // useEffect(() => {
  //   if (
  //     !deepEqual(data, initialState) ||
  //     itemsRows.length !== initialAttachments.length
  //   ) {
  //     handleNavigationBlocker(true);
  //   }
  //   return () => {
  //     handleNavigationBlocker(false);
  //   };
  // }, [data, aTags]);

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (params.view) return;
    const isDataModified = JSON.stringify(data) !== JSON.stringify(initialState);
    const isAttachmentsModified = itemsRows.length !== initialAttachments.length;

    const shouldBeDirty = isDataModified || isAttachmentsModified;

    if (shouldBeDirty !== isDirty) {
      setIsDirty(shouldBeDirty);
    }
  }, [data, itemsRows, initialState, initialAttachments, isDirty]);

  useEffect(() => {
    dispatch(setNavigationBlocked(isDirty));
  }, [isDirty, dispatch]);

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  }, []);
  function formVaidation(objData) {
    let isvalid = true;
    let errorArr = [];
    let obj = { ...data };
    Object.keys(objData).map((itemKey) => {
      if (itemKey === 'seriesVouchers') {
        if (objData[itemKey]?.value === '') {
          isvalid = false;
          obj.errorFields.seriesVouchers = 'Invoice Series Name is Required';
          obj.errorStatus.seriesVouchers = true;
          errorArr.push('Invoice Series Name');
        } else {
          obj.errorFields.seriesVouchers = '';
          obj.errorStatus.seriesVouchers = false;
        }
      }
      if (itemKey === 'currencyRate') {
        if (objData[itemKey] === 0 || objData[itemKey] === '') {
          isvalid = false;
          obj.errorStatus.currencyRate = true;
          setTabValue('2');
          showWarningSnackbar('Please enter the Currency Rate');
        } else {
          obj.errorFields.currencyRate = '';
          obj.errorStatus.currencyRate = false;
        }
      }
      if (itemKey === 'invoiceDate') {
        const startDate = userPreferece.financialYear.startdate * 1000;
        const endDate = userPreferece.financialYear.enddate * 1000;

        const minDate = moment(params?.id && !isNaN(params.id) ? firstInvoiceDate || startDate : lastInvoiceDate || startDate);

        const maxDate = moment(params?.id && !isNaN(params.id) ? nextInvoiceDate || endDate : endDate);

        if (!objData[itemKey]?.trim()) {
          isvalid = false;
          obj.errorFields.invoiceDate = 'Invoice Date is required';
          obj.errorStatus.invoiceDate = true;
          errorArr.push('Invoice Date');
        } else if (moment(objData[itemKey], 'YYYY-MM-DD').isBefore(minDate) || moment(objData[itemKey], 'YYYY-MM-DD').isAfter(maxDate)) {
          isvalid = false;
          obj.errorFields.invoiceDate = `Invoice Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format(
            'DD MMM YYYY'
          )}`;
          showWarningSnackbar(`Invoice Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}`);
          obj.errorStatus.invoiceDate = true;
        } else {
          obj.errorFields.invoiceDate = '';
          obj.errorStatus.invoiceDate = false;
        }
      }

      if (registrationType != 1) {
        if (itemKey === 'taxability') {
          if (objData[itemKey].value === '') {
            isvalid = false;
            obj.errorFields.taxability = 'Taxability is required';
            obj.errorStatus.taxability = true;
            errorArr.push('Taxability');
          } else {
            obj.errorFields.taxability = '';
            obj.errorStatus.taxability = false;
          }
        }
      }

      // if (itemKey === "paymentType") {
      //   if (objData[itemKey]?.trim()?.length <= 0) {
      //     isvalid = false;
      //     obj.errorFields.paymentType = "Payment Type is Required";
      //     obj.errorStatus.paymentType = true;
      //     setPaymentAccordion(true);
      //   } else {
      //     obj.errorFields.paymentType = "";
      //     obj.errorStatus.paymentType = false;
      //   }
      // }

      if (data?.cashPayment === true && Number(totNetAmt) > 0) {
        if (itemKey === 'receivedAmount') {
          if (objData[itemKey] == 0 || isNaN(Number(objData[itemKey]))) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Cash Received Amount is Required';
            obj.errorStatus.receivedAmount = true;
          } else if (Number(netAmountToPay) < Number(data.receivedAmount)) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Amount should be less than Grand Total';
            obj.errorStatus.receivedAmount = true;
          } else {
            obj.errorFields.receivedAmount = '';
            obj.errorStatus.receivedAmount = false;
          }
        }
      }

      if (data?.bankPayment === true && Number(totNetAmt) > 0) {
        if (itemKey === 'bankReceivedAmount') {
          if (objData[itemKey] == 0 || isNaN(Number(objData[itemKey]))) {
            isvalid = false;
            obj.errorFields.bankReceivedAmount = 'Bank Received Amount is Required';
            obj.errorStatus.bankReceivedAmount = true;
          } else if (Number(netAmountToPay) < Number(data.receivedAmount)) {
            isvalid = false;
            obj.errorFields.bankReceivedAmount = 'Amount should be less than Grand Total';
            obj.errorStatus.bankPayment = true;
          } else {
            obj.errorFields.bankReceivedAmount = '';
            obj.errorStatus.bankReceivedAmount = false;
          }
        }
      }

      if (itemKey === 'adjustments') {
        if (!new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(objData[itemKey]) && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.adjustments = 'Invalid Amount Format';
          obj.errorStatus.adjustments = true;
        } else {
          obj.errorFields.adjustments = '';
          obj.errorStatus.adjustments = false;
        }
      }

      // if (itemKey === "bankReferenceNo") {
      //   if (objData["paymentType"] === "Bank") {
      //     if (
      //       !new RegExp(/^\d{9,18}$/).test(objData[itemKey]) &&
      //       objData[itemKey].trim().length > 0
      //     ) {
      //       isvalid = false;
      //       obj.errorFields.bankReferenceNo =
      //         "Invalid Bank/UPI Reference number";
      //       obj.errorStatus.bankReferenceNo = true;
      //       setPaymentAccordion(true);
      //     } else {
      //       obj.errorFields.bankReferenceNo = "";
      //       obj.errorStatus.bankReferenceNo = false;
      //     }
      //   }
      // }
      if(Number(voucherFlag)===-1){
      if (itemKey === 'voucherNumber') {
        const { valid, message } = CheckVoucherValid(objData[itemKey],'Invoice Number');
                if (objData[itemKey]?.trim()?.length <= 0) {
                  isvalid = false;
                  obj.errorFields.voucherNumber = 'Invoice Number is Required';
                  obj.errorStatus.voucherNumber = true;
                  errorArr.push('Invoice Number');
                }
                else if(!valid){
                   isvalid = false;
                  obj.errorFields.voucherNumber =message;
                  obj.errorStatus.voucherNumber = true;
                  showWarningSnackbar(message);
                }  else {
          let valid = true;
          voucherArr.map((ele) => {
            if (ele.InvoiceNumber !== invoiceEntry.InvoiceNumber) {
              if (ele.VoucherNumber === data.voucherNumber) {
                valid = false;
              }
            }
          });
          if (valid == false) {
            isvalid = false;
            obj.errorFields.voucherNumber = 'Invoice Number already exists';
            obj.errorStatus.voucherNumber = true;
          } else {
            obj.errorFields.voucherNumber = '';
            obj.errorStatus.voucherNumber = false;
          }
        }
      }
    }

      // if (data.paymentType !== "Credit") {
      //   if (itemKey === "transactionVoucher") {
      //     if (objData[itemKey].trim().length <= 0) {
      //       isvalid = false;
      //       obj.errorFields.transactionVoucher = "Voucher Number is Required";
      //       obj.errorStatus.transactionVoucher = true;
      //       setPaymentAccordion(true);
      //     } else {
      //       let valid = true;
      //       transVoucherArr.map((ele) => {
      //         if (ele.VoucherNumber !== currentVoucherNo)
      //           if (ele.VoucherNumber === data.transactionVoucher) {
      //             valid = false;
      //           }
      //       });

      //       if (valid == false) {
      //         isvalid = false;
      //         obj.errorFields.transactionVoucher =
      //           "Voucher Number already exists";
      //         obj.errorStatus.transactionVoucher = true;
      //         setPaymentAccordion(true);
      //       } else {
      //         obj.errorFields.transactionVoucher = "";
      //         obj.errorStatus.transactionVoucher = false;
      //       }
      //     }
      //   }
      // }

      if (itemKey === 'remarks') {
        if (objData[itemKey]?.trim()?.length > 250 && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.remarks = 'Description must be less than 250 characters';
          obj.errorStatus.remarks = true;
        } else {
          obj.errorFields.remarks = '';
          obj.errorStatus.remarks = false;
        }
      }
      if (itemKey === 'partyContactNumber') {
        if (objData[itemKey]?.length > 0) {
          const phoneNumber = objData[itemKey].trim();
       const validateContactNumber = (number) => /^\d{10,15}$/.test(number); 

          if (!validateContactNumber(phoneNumber)) {
            isvalid = false;
            obj.errorFields.partyContactNumber = "Contact number must have at least 10 digits."
            obj.errorStatus.partyContactNumber = true;
          } else {
            obj.errorFields.partyContactNumber = '';
            obj.errorStatus.partyContactNumber = false;
          }
        } else {
          obj.errorFields.partyContactNumber = '';
          obj.errorStatus.partyContactNumber = false;
        }
      }
    });
    const validErrors = errorArr.filter((e) => !!e && e.trim?.().length > 0);

    if (!isvalid) {
      if (validErrors.length === 1) {
        showWarningSnackbar(`${validErrors[0]} is required`);
      } else if (validErrors.length > 1) {
        const lastField = validErrors.pop();
        const errorText = `${validErrors.join(', ')} and ${lastField} are required`;
        showWarningSnackbar(errorText);
      }
    }
    setData(obj);

    let balance = Number(netAmountToPay) - (Number(data?.receivedAmount) + Number(data?.bankReceivedAmount));
    if (Number(netAmountToPay) > 0) {
      if (Number(balance) > 0) {
        showWarningSnackbar(
          'Please complete the payment.You need to pay the balance amount' +
            ' ' +
            data?.currency?.sign +
            ' ' +
            MoneyFormatv3(Number(balance))
        );
        return;
      }
      if (Number(balance) < 0) {
        showWarningSnackbar(
          'You have overpaid by' +
            ' ' +
            ' ' +
            data?.currency?.sign +
            ' ' +
            MoneyFormatv3(Number(balance) * -1) +
            ' ' +
            'Please adjust the payment amount.'
        );
        return;
      }
    }
    if (isvalid) {
      if (Number(totTaxAmt + totGST + totGSTCess) > 99999999999) {
        showWarningSnackbar(`Total Net Amount must be less than ${data?.currency?.sign}1,000 crore.`);
        isvalid = false;
      }
    }
    return isvalid;
  }
  function checkPriceTypeWithInvDate(value) {
    const updatedTableArr = [...items];
    let isValid = true;

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');
    updatedTableArr.forEach((subele) => {
      if (subele?.effectiveFrom !== 0) {
        const tempEffectiveFrom = moment(subele.effectiveFrom * 1000).startOf('day');
        const tempEffectiveTo =
          subele.effectiveTo === '' || subele?.effectiveTo === 0 ? null : moment(subele.effectiveTo * 1000).startOf('day');

        const normalizedInvoiceDate = moment(momentInvoiceDate).startOf('day');
        const isOutsideRange =
          normalizedInvoiceDate.isBefore(tempEffectiveFrom) || (tempEffectiveTo && normalizedInvoiceDate.isAfter(tempEffectiveTo));

        if (isOutsideRange) {
          isValid = false;
          subele.invalidDate = true;
        } else {
          subele.invalidDate = false;
        }
      }
    });

    if (!isValid) {
      showWarningSnackbar('The highlighted items do not match the invoice date range. Please verify the effective dates.');
    }
    return isValid;
  }
  async function getInvoiceMasterData(data) {
    try {
      // setBackdropOpen(true);
      const res = await API.graphql(graphqlOperation(getInvoiceMasterCustom, { invoiceid: data }));
      if (res.data.getInvoiceMaster !== null) {
        setInvoiceEntry(res.data.getInvoiceMaster?.[0]);
        setSavedPostingDate(res.data.getInvoiceMaster[0]?.invoicedate);
        // setBackdropOpen(false);
      }else{
         setSavedPostingDate("");
        setData((prev)=>({
          ...prev,
          invoiceDate:""

        }));
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  // async function getLastSalesInvoice() {
  //   try {
  //     const res = await API.graphql(
  //       graphqlOperation(getMinMaxInvoiceDate, {
  //         serialnumber:data?.seriesVouchers?.value,
  //         invoicetypecd: 'Pos',
  //         invoiceid: params?.id && !isNaN(params?.id) ? params?.id : 0,
  //       })
  //     );
  //     let lastInvoiceDate = '';
  //     if (res?.data?.getMinMaxInvoiceDate !== null) {
  //       if (voucherFlag !== -1) {
  //         if (res?.data?.getMinMaxInvoiceDate?.previnvoicedate !== null) {
  //           setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.previnvoicedate);
  //            if(params?.id && !isNaN(params?.id)){
  //                         const lasteInvoiceDate= res?.data?.getMinMaxInvoiceDate?.previnvoicedate;
  //                         const checkDateValid= await checkDateMyPostDate(lasteInvoiceDate,savedPostingDate);
  //                         if(checkDateValid){
  //                           return;
  //                         }
  //                       }
  //         } else {
  //           setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
  //           if (params?.id === '' || isNaN(params?.id)) {
  //             if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
  //               setData((prev) => ({
  //                 ...prev,
  //                 invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
  //               }));
  //               setInitialState((prev) => ({
  //                 ...prev,
  //                 invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
  //               }));
  //             } else {
  //               if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
  //                 setData((prev) => ({
  //                   ...prev,
  //                   invoiceDate: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
  //                 }));
  //                 setInitialState((prev) => ({
  //                   ...prev,
  //                   invoiceDate: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
  //                 }));
  //               }
  //             }
  //           }
  //         }
  //         if (res?.data?.getMinMaxInvoiceDate?.nextinvoicedate !== null) {
  //           setNextInvoiceDate(res?.data?.getMinMaxInvoiceDate?.nextinvoicedate);
  //         }
  //         if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
  //           lastInvoiceDate = res?.data?.getMinMaxInvoiceDate?.latestinvoicedate??'';
  //           setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.latestinvoicedate);
  //              if(params?.id==='' || isNaN(params?.id)){
  //           const checkDateValid=  await  checkDateMyPostDate(lastInvoiceDate,savedPostingDate);
  //              if(checkDateValid){
  //               return;
  //             }
  //           }
  //           if (params?.id === '' || isNaN(params?.id)) {
  //             if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
  //               setData((prev) => ({
  //                 ...prev,
  //                 invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
  //               }));
  //               setInitialState((prev) => ({
  //                 ...prev,
  //                 invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
  //               }));
  //             } else {
  //               if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
  //                 setData((prev) => ({
  //                   ...prev,
  //                   invoiceDate: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
  //                 }));
  //                 setInitialState((prev) => ({
  //                   ...prev,
  //                   invoiceDate: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
  //                 }));
  //               }
  //             }
  //           }
  //         } else {
  //           setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
  //         }
  //       } else {
  //         lastInvoiceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate??'';
  //         setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
  //         setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
  //       }
  //     }

  //     if (lastInvoiceDate === '') {
  //         const startDate= moment(userPreferece?.financialYear?.startdate * 1000).format('YYYY-MM-DD');
  //       if (InvoiceSettings?.defaultsetting == 1) {
  //         console.log(InvoiceSettings);
  //         setpromptInvoiceSetting(true);
  //       }

  //       setData((prev) => ({
  //                           ...prev,
  //                           invoiceDate: res?.data?.getMinMaxInvoiceDate?.openingbalancedate??startDate,
  //                           dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate??startDate,
  //                         }));
  //                 setInitialState((prev) => ({
  //                           ...prev,
  //                           invoiceDate: res?.data?.getMinMaxInvoiceDate?.openingbalancedate??startDate,
  //                           dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate??startDate,
  //                         }));
  //     }
  //   } catch (error) {
  //     setBackdropOpen(false);
  //     console.log('error', error);
  //   }
  // }
   async function getLastSalesInvoice() {
      try {
        const res = await API.graphql(
          graphqlOperation(getMinMaxInvoiceDate, {
            serialnumber:data?.seriesVouchers?.value,
            invoicetypecd: 'Pos',
            invoiceid: params?.id && !isNaN(params?.id) ? params?.id : 0,
          })
        );
        let lastInvoiceDate = '';
        if (res?.data?.getMinMaxInvoiceDate !== null) {
          if (voucherFlag !== -1) {
            if (res?.data?.getMinMaxInvoiceDate?.previnvoicedate !== null) {
              setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.previnvoicedate);
              if(invoiceEntry?.invoiceid){
               
                const lasteInvoiceDate= res?.data?.getMinMaxInvoiceDate?.previnvoicedate;
                const checkDateValid= await checkDateMyPostDate(lasteInvoiceDate,savedPostingDate);
                if(checkDateValid){
                  return;
                }
              }
            } else {
                if(invoiceEntry?.invoiceid){
                const lasteInvoiceDate= res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
                const checkDateValid= await checkDateMyPostDate(lasteInvoiceDate,savedPostingDate);
                if(checkDateValid){
                  return;
                }
              }
              setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
              if (params?.id === '' || isNaN(params?.id)) {
                if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
                  setData((prev) => ({
                    ...prev,
                    invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  }));
                  setInitialState((prev) => ({
                    ...prev,
                    invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  }));
                } else {
                  if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
                     const currentPostingDate = moment(savedPostingDate * 1000).format('YYYY-MM-DD');
    const opbDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
    
    const selectedInvoiceDate = currentPostingDate > opbDate ? savedPostingDate : res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
                    setData((prev) => ({
                      ...prev,
                      invoiceDate: selectedInvoiceDate,
                      // res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                      // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    }));
                    setInitialState((prev) => ({
                      ...prev,
                      invoiceDate:selectedInvoiceDate
                      //  res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                      // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    }));
                  }
                }
              }
            }
            if (res?.data?.getMinMaxInvoiceDate?.nextinvoicedate !== null) {
              setNextInvoiceDate(res?.data?.getMinMaxInvoiceDate?.nextinvoicedate);
            }
            if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
              lastInvoiceDate = res?.data?.getMinMaxInvoiceDate?.latestinvoicedate??'';
              setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.latestinvoicedate);
                if(params?.id==='' || isNaN(params?.id)){
              const checkDateValid=  await  checkDateMyPostDate(lastInvoiceDate,savedPostingDate);
                 if(checkDateValid){
                  return;
                }
              }
              if (params?.id === '' || isNaN(params?.id)) {
                if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
                  setData((prev) => ({
                    ...prev,
                    invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  }));
                  setInitialState((prev) => ({
                    ...prev,
                    invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  }));
                } else {
                  if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
                    const currentPostingDate = moment(savedPostingDate * 1000).format('YYYY-MM-DD');
    const opbDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate ;
    
    const selectedInvoiceDate = currentPostingDate > opbDate ? savedPostingDate : res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
                    setData((prev) => ({
                      ...prev,
                      invoiceDate:selectedInvoiceDate,
                      //  res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                      // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    }));
                    setInitialState((prev) => ({
                      ...prev,
                      invoiceDate:selectedInvoiceDate,
                      //  res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                      // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    }));
                  }
                }
              }
            } else {
              setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
            }
          } else {
            lastInvoiceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate??'';
            setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
            setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
             if (params?.id === '' || isNaN(params?.id)) {
                          const checkDateValid = await checkDateMyPostDate(lastInvoiceDate, savedPostingDate);
                          if (checkDateValid) {
                            return;
                          }
                        }else{
                           if (invoiceEntry?.invoiceid) {
                          const lasteInvoiceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
                          const checkDateValid = await checkDateMyPostDate(lasteInvoiceDate, savedPostingDate);
                          if (checkDateValid) {
                            return;
                          }
                        }
                      }
          }
        }
        if (lastInvoiceDate === '') {
        const startDate=savedPostingDate?moment(savedPostingDate * 1000).format('YYYY-MM-DD'):res?.data?.getMinMaxInvoiceDate?.openingbalancedate ?? moment(userPreferece.financialYear.startdate * 1000).format('YYYY-MM-DD');
          if (InvoiceSettings?.defaultsetting == 1 && !params?.id) {
            setpromptInvoiceSetting((prev) => ({ ...prev, open: true }));
          }
          
            if (params?.id && !isNaN(params.id)) {
          if (invoiceEntry && Object.keys(invoiceEntry).length > 0) {
            setData((prev) => ({
              ...prev,
              invoiceDate: startDate,
            }));
            setInitialState((prev) => ({
              ...prev,
              invoiceDate: startDate,
            }));
          }
        } else {
          setData((prev) => ({
            ...prev,
            invoiceDate: startDate,
          }));
          setInitialState((prev) => ({
            ...prev,
            invoiceDate: startDate,
          }));
        }
           
        }
      } catch (error) {
        setBackdropOpen(false);
        console.log('error', error);
      }
    }
  async function savePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      let masterArr = [];
      let linkedArr = [];
      const comments = data.remarks.split('\n');
      if (data.paymentType !== 'Credit') {
        const masterData = {
          bankreferencenumber: data.bankReferenceNo,
          comments: comments?.join('**'),
          entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          transactiontypecd: data.paymentType === 'Cash' ? 'CashReceipt' : data.paymentType === 'Bank' ? 'BankReceipt' : 'Credit',
          vouchercode: transGeneralSettingsFlag === -1 ? data.transactionVoucher : '',
          serialnumber: data.transactionSeries.value,
          cancelflag: 0,
        };

        masterArr.push(masterData);
        paymentTransArr.map((ele, index) => {
          const paymentTransDetails = {
            accountid: ele.accID,
            comments: comments?.join('**'),
            creditamount: Number(ele.creditAmt).toFixed(2),
            debitamount: Number(ele.debitAmt).toFixed(2),
            entryordernumber: index + 1,

            transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
            cancelflag: 0,
          };
          tranSDetailsArr.push(paymentTransDetails);
        });

        const linkCurrentPayment = {
          linkedamount: data.receivedAmount,
          transactiontypecd: 'PosInvoice',
          isdirect: 1,
          objectattribute: data.voucherNumber,
          objectid: invID,
          objecttype: data.paymentType,

          accountid: partyAccountID === '' ? 0 : partyAccountID,
          paymentvouchernumber: data?.transactionVoucher,
        };
        linkedArr.push(linkCurrentPayment);
        linkedTransArr.map(async (ele) => {
          let linkTransData = {
            linkedamount: ele.linkedamount,
            transactiontypecd: 'PosInvoice',
            isdirect: 0,
            objectattribute: data?.voucherNumber,
            objectid: invID,
            objecttype: ele.transactiontypecd,
            transactionid: ele.transactionid,
          };
          linkedArr.push(linkTransData);
        });
        const result = await API.graphql(
          graphqlOperation(createTransactionWithSpecificTime, {
            transactionmaster: JSON.stringify(masterArr),
            transactiondetails: JSON.stringify(tranSDetailsArr),
            transactionattachment: JSON.stringify([]),
            transactiontdsdetails: JSON.stringify([]),
            transactionrelation: JSON.stringify(linkedArr),
            mode: 1,
            transactiontcsdetails: JSON.stringify([]),
          })
        );
        let url = path + `Invoices/Receipt/Ledgerx_Receipt_${data.transactionVoucher}.pdf`;
        await createPdf({
          path: url,
          type: 'receipt',
          transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
        });
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  async function saveChanges(obj) {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      partyContactNumber,
      paymentType,
      receivedAmount,
      receivedAccount,
      bankReceivedAmount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      bankReceivedAmount,
      partyContactNumber,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };
    let itemValid = true;
    if (formVaidation(formData)) {
      setBackdropOpen(true);
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }
 if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                requireds.push('GST Rate');
                errorArr.push('GSTRate' + ind);
              }
            }
          }
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            // partyType === 'CUSTOMER'
            companyType === 2
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
          if (ele?.qty == 0 || ele?.qty === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('qty' + ind);
            requireds.push('Quantity');
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push(' Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }

         
          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0) {
            setItems([newItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }
      if (isvalid) {
        isvalid = checkPriceTypeWithInvDate(data?.invoiceDate);
      }
      if (isvalid) {
        try {
          const comments = data.remarks;
          let invMasterArr = [];
          let invDispatchArr = [];
          let invLineItemArr = [];
          let invNonLineItemArr = [];
          let tcsArr = [];
          let invAddArr = [];
          let invTransactionArray = [];
          let invLineGstArr = [];
          let invLineNonGstArr = [];
          let randomNum = Math.floor(Math.random() * 100 + 1);
          let timeStamp = Math.floor(new Date().getTime() / 1000);
          let randomNumber = randomNum + timeStamp.toString().slice(3, 10);
          const phoneContacts = {
            callallowed: String('0'),
            countrycode: String('1'),
            objecttype: String('Pos'),
            id: Number(0),
            objectid: Number(companyData.companyid),
            phonenumber: String(data.partyContactNumber || ''),
            promotionssignup: String('0'),
            smsallowed: String('0'),
            verifieddatetime: Number(0),
            whatsappallowed: String('0'),
            expiredtimestamp: Number(0),
          };

          // const resPhoneContact = await API.graphql(
          //   graphqlOperation(createPhoneContacts, {
          //     createPhoneContactsInput: [phoneContacts],
          //   })
          // );
          const posPartyData = {
            // pospartyid: 0,
            partyname: String(partyName || ''),
            // partycontactnumberid: Number(
            //   resPhoneContact?.data?.createPhoneContacts?.[0]?.id || 0
            // ),
            // expiredtimestamp: Number(0),
          };

          // const resPosData = await API.graphql(
          //   graphqlOperation(createPOSParty, {
          //     createPOSPartyInput: posPartyData,
          //   })
          // );
          // const posData = {
          //   posid: 0,
          //   expiredtimestamp: Number(0),
          //   partyposid: Number(resPosData.data.createPOSParty.pospartyid),
          // };
          // const resInvoicePosData = await API.graphql(
          //   graphqlOperation(createInvoicePOSDetails, {
          //     createInvoicePOSDetailsInput: posData,
          //   })
          // );
          const invMasterData = {
            invoicetypecd: 'PosInvoice',
            partyid: Number(0),
            paymentaccountid: receivedAccount.value === '' || data?.cashPayment === false ? 0 : Number(receivedAccount.value),
            invoicedate: Math.floor(new Date(invoiceDate).getTime() / 1000),
            invoicenumber: data.voucherNumber === '' ? '0' : data.voucherNumber.toString(),
            customerordernumber: orderNumber === '' ? '0' : orderNumber.toString(),
            customerorderdate: customerOrderDate ? Math.floor(new Date(customerOrderDate).getTime() / 1000) : 0,
            invoiceamount: Number(netAmountToPay),
            paymenttype: paymentType,
            creditduration: creditPeriod === '' ? 0 : Number(creditPeriod),
            invoicebillingaddressid: 10,
            invoicedeliveryaddressid: 10,
            invoicetaxabletypecd: taxability?.value || '',
            receipturl: '',
            invoicelinetypecd: '',
            invoicecurrencycd: '',
            exchangerate: Number(receivedAmount),
            comments: comments,
            receivedamount: Number(receivedAmount),
            adjustmentamount: Number(adjustments),
            placeofsupply:companyPlaceCode,
            //  placeOfSupply.value,
            balancedueamount: Number(data.balanceDueAmt),
            reversechargeflag: data.reverseChargeFlag === '' ? 0 : Number(data.reverseChargeFlag),
            transactiontypecd: 'PosInvoice',
            entrydate: Math.floor(Date.now() / 1000),
            bankreferencenumber: paymentType === 'Bank' ? data?.bankReferenceNo : '',
            tcsapplicableflag: Number(data.tcsFlag),
            // serialnumber: data.seriesVouchers.value,
             serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
            // consigneename: data.consigneeName !== "" ? data.consigneeName : data.partyName.label,
            // consigneegstin: data.consigneeGST !== "" ? data.consigneeGST : data.gstin,
            consigneename: '',
            consigneegstin: '',
            companystate: companyState,
            roundoffamount: Number(data.roundOff),
            discounttype: Number(data.adjustmentsType),
            discountvalue: Number(data.adjustmentsValue),
            currencycode: data.currency.value,
            currencyrate: Number(data.currencyRate),
            invoicepdf: uri, // Placeholder, since original had no `invoicepdf`
            bankaccountid:
              data?.bankReceivedAccount?.value === '' || data?.bankPayment === false ? 0 : Number(data.bankReceivedAccount.value),
            bankamount: Number(data?.bankReceivedAmount || 0),
            serialflag:Number(generalSettingsFlag)===-1?0:Number(data?.seriesVouchers?.serialflag)
          };

          invMasterArr.push(invMasterData);
          if (items.length > 0) {
            items.map((ele, index) => {
              if (ele?.itemCode?.value !== '') {
                const lineItem = {
                  invoiceitemid: index + 1,
                  lineitemnumber: index + 1,
                  invoicelineitemtype: 'ITEM',
                  itemid: Number(ele.name.value),
                  quantity: Number(ele.qty),
                  unittypecd: ele.units,
                  itemrate: Number(ele.rate),
                  itemamount: Number(ele.amount),
                  itemdiscount: Number(ele.dicount),
                  netamount: Number(ele.netAmount),
                  hsnsaccode: String(ele.HSN.value === '' ? '0' : ele.HSN.value),
                  taxability: data?.taxability.value || '',
                  pricetype: ele?.priceType?.label || '',
                  manualdiscount: ele?.manualDiscount === true ? 1 : 0,
                 manualcess: Number(ele?.manualCess),
                  
                  pricetypeid: Number(ele.priceType?.value || 0),
                  itemtype:String(ele.itemType),
                  manualgst:Number(ele?.manualGSTFlag),
                   discounttype:String(ele?.discountType),
            discountrate:Number(ele.discountRate),
                };

                invLineItemArr.push(lineItem);
                const gstData = {
                  invoiceitemid: index + 1,
                  gstrate: Number(ele.GSTRate),
                  gsttypecd: ele.gstTypeCd || '', // replace with correct value source if available
                  gstamount: Number(ele.IGST),
                  cessamount: Number(ele.GSTCess),
                  cessrate:Number(ele.cessRate),
                  cesstype:String(ele?.cessType)
                };

                invLineGstArr.push(gstData);
              }
            });
          }
          const tcsData = {
            tcsapplicablecd: data.tcsFlag === '' ? '0' : String(data.tcsFlag),
            totaltaxableamount: Number(totTaxAmt),
            ineligibletcflag: data.ineligibleITCFlag === '' ? 0 : Number(data.ineligibleITCFlag),
            reversechargeflag: data.reverseChargeFlag === '' ? 0 : Number(data.reverseChargeFlag),
            gstcesstotal: Number(totGSTCess),
            tcsamount: Number(data.tcsAmount),
            adjustmentamount: Number(data.adjustments),
            tcssection: data.tcsOptions || '',
            tcspercentage: Number(data.tcsPercent),
            tcsmanual: Number(data.manualTcsFlag),
          };

          tcsArr.push(tcsData);
          invTransArr.map((ele, ind) => {
            let obj = {
              transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
              accountid: Number(ele.accID),
              creditamount: Number(ele.creditAmt),
              debitamount: Number(ele.debitAmt),
              comments: data.remarks || '',
            };
            invTransactionArray.push(obj);
          });
          // const attachedArr = itemsRows.map((ele) => ({
          //   documentname: ele.documentname,
          //   attachmentname: ele.imagename,
          //   attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`,
          //   type: ele?.type?.split("/")[1],
          // }));
          const attachedArr = itemsRows.map((ele) => ({
            documentname: ele.documentname || '', // String!
            attachmentname: ele.imagename || '', // String!
            attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`, // String!
            type: ele?.type?.split('/')[1] || '', // String!
          }));

          const resSalesInvoice = await API.graphql(
            graphqlOperation(createSalesPosInvoiceTemp, {
              createSalesInvoiceInput: {
                posphonecontacts: [phoneContacts],
                posparty: [posPartyData],
                // invoiceposdetails:[posData],
                denominations: [],
                invoicedispatch: invDispatchArr,
                invoicelinegst: invLineGstArr,
                invoicelinenongst: invLineNonGstArr,
                invoicelineitems: invLineItemArr,
                invoicelinenonitems: invNonLineItemArr,
                invoicetcsdetails: tcsArr,
                invoicetransactionmaster: invMasterArr,
                partyaddressentity: invAddArr,
                transactiondetails: invTransactionArray,
                invoiceattachment: attachedArr,
              },
            })
          );

          if (resSalesInvoice.data.createSalesPosInvoiceTemp.statuscode == 'Success') {
            setBackdropOpen(false);
            // addAttachmets(resSalesInvoice.data.createSalesInvoice.InvoiceID);
            // savePaymentDetails(
            //   resSalesInvoice.data.createSalesInvoice.invoiceid
            // );
            let responses = itemsRows.map((element) => {
              if (element.file) {
                return uploadToServer(
                  element.file,
                  element.imagename.replace('${id}', resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid),
                  element.type
                );
              }
            });
            await Promise.all(responses);
            createPdf({
              path: url,
              type: 'pos',
              invoiceids: resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid,
            });
            showSuccessSnackbar('Pos generated successfully');
            dispatch(dashboardApi.util.invalidateTags(['dashboard',"bizview"]));
            
            // Set email data for POS customer
            setSelected([
              {
                PartyDisplayName: data.partyName || 'POS Customer',
                Email: data.partyEmail || '',
                PartyID: 0, // POS customers don't have party IDs
                invoiceid: resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid,
                voucherNumber: data.voucherNumber,
              },
            ]);
            
            if (obj.new === false) {
              setShareOpen(uri);
              // navigate("/salesInvoiceReport");
            } else {
              // window.location.reload();
              setBackdropOpen(false);
              setData((prev) => ({
                ...resetData,
                invoiceDate: prev?.invoiceDate,
              }));
              getLastSalesInvoice();
              dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listVoucherSettings', id: 'PosInvoice' }]));
              dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
              // getVoucherDetails("Receipt");
              setItemValid(true);
              setNonItems([resetNonItems]);
              setItems([resetItems]);
              setItemsRows([]);
              setSelected([]); // Clear email selection for new invoice
            }
          } else {
            setBackdropOpen(false);
            // setItemValid(false);
            // showWarningSnackbar("Please complete the highlighted fields");
            showErrorSnackbar(resSalesInvoice.data.createSalesPosInvoiceTemp.statusmessage);
          }
        } catch (error) {
          setBackdropOpen(false);

          const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
          const parsedMessage = JSON.parse(rawMessage).message;
          const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
          showWarningSnackbar(errorMessage);
          console.log('error', error);
        } finally {
          dispatch(dispatch(setNavigationBlocked(false)));
        }
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
      }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }
  async function saveEditChanges() {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      partyContactNumber,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      partyContactNumber,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };
    let itemValid = true;
    if (formVaidation(formData)) {
      setBackdropOpen(true);
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }

          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                requireds.push('GST Rate');
                errorArr.push('GSTRate' + ind);
              }
            }
          }
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            // partyType === 'CUSTOMER'
            companyType === 2
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
          if (ele?.qty == 0 || ele?.qty === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('qty' + ind);
            requireds.push('Quantity');
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push(' Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }

          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0) {
            setItems([newItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }
      if (isvalid) {
        isvalid = checkPriceTypeWithInvDate(data?.invoiceDate);
      }
      if (isvalid) {
        const comments = data.remarks;
        const phoneContacts = {
          id: invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]?.relatedphonecontacts[0]?.id,
          callallowed: '',
          countrycode: '1',
          objecttype: 'Pos',
          objectid: companyData.companyid,

          phonenumber: data.partyContactNumber,
          promotionssignup: '',
          smsallowed: '',
          verifieddatetime: 0,
          whatsappallowed: '',
          expiredtimestamp: 0,
          financialyearid: userPreferece?.financialYear?.financialyearid
        };

        const resPhoneContact = await API.graphql(
          graphqlOperation(createPhoneContacts, {
            createPhoneContactsInput: [phoneContacts],
          })
        );
        const posPartyData = {
          partycontactnumberid: invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]?.relatedphonecontacts[0]?.id,
          partyname: partyName,
          pospartyid: invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]?.pospartyid,
          expiredtimestamp: 0,
        };
        const resPosData = await API.graphql(
          graphqlOperation(createPOSParty, {
            createPOSPartyInput: posPartyData,
          })
        );

        const posData = {
          posid: invoiceEntry.relatedinvoiceposdetails[0]?.posid,
          partyposid: invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]?.pospartyid,
          expiredtimestamp: 0,
        };
        const resInvoicePosData = await API.graphql(
          graphqlOperation(createInvoicePOSDetails, {
            createInvoicePOSDetailsInput: posData,
          })
        );

        const masterData = {
          adjustmentamount: Number(adjustments),
          comments: comments,
          expiredtimestamp: 0,
          reversechargeflag: data.reverseChargeFlag === '' ? 0 : data.reverseChargeFlag,
          balancedueamount: Number(data.balanceDueAmt),
          creditduration: Number(creditPeriod),
          customerordernumber: orderNumber === '' ? 0 : orderNumber,
          customerorderdate: customerOrderDate ? Math.floor(new Date(customerOrderDate).getTime() / 1000) : 0,
          exchangerate: Number(receivedAmount),
          invoiceamount: netAmountToPay,
          invoicebillingaddressid: 10,
          invoicecurrencycd: '',
          invoicedate: Math.floor(new Date(invoiceDate).getTime() / 1000),
          invoicedeliveryaddressid: 10,
          invoiceid: invoiceEntry.invoiceid,
          invoicenumber:data?.voucherNumber===""?String(data.seriesVouchers.label):String(data?.voucherNumber),
          // serialnumber: data.seriesVouchers.value,
           serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
          invoicetaxabletypecd: taxability?.value,
          invoicetypecd: 'PosInvoice',
          partyid: invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]?.pospartyid,
          paymentaccountid: receivedAccount.value == '' || data?.cashPayment === false ? 0 : receivedAccount.value,
          placeofsupply: companyPlaceCode,
          // placeOfSupply.value,

          paymenttype: paymentType,
          receipturl: '',
          receivedamount: data?.cashPayment === false ? 0 : Number(receivedAmount),
          tcsapplicableflag: data.tcsFlag,
          consigneename: '',

          consigneegstin: '',
          invoicepdf: uri,
          companystate: companyState,
          roundoffamount: Number(data.roundOff).toFixed(2),
          discounttype: Number(data.adjustmentsType),
          discountvalue: Number(data.adjustmentsValue),
          currencycode: data.currency.value,
          currencyrate: data.currencyRate,
          cancelremark: '',
          deleteremark: '',
          financialyearid: userPreferece?.financialYear?.financialyearid,
          cancelflag: 0,
          invoicelinetyped: '',
          paymentstatus: 0,
          bankaccountid: data?.bankReceivedAccount?.value === '' || data?.bankPayment === false ? 0 : data?.bankReceivedAccount?.value,
          bankamount: data?.bankReceivedAmount?.value === 0 || data?.bankPayment === false ? 0 : data?.bankReceivedAmount,
          serialflag:Number(generalSettingsFlag)===-1?0:Number(data?.seriesVouchers?.serialflag)
        };
        updateInvoiceMasterData(masterData);
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
      }
    }
  }
  async function updateInvoiceMasterData(masterData) {
    try {
      let variables = {};
      let invLineItemArr = [];
      let invLineGstArr = [];
      let invTransactionArray = [];
      let currentMaxInvoiceItemId = Math.max(
  0,
  ...[...items, ...deletedItems]
    .map((ele) => Number(ele?.invoiceitemid || 0))
    .filter((id) => !isNaN(id))
);
      [...items, ...deletedItems].map(async (ele, index) => {
        if (ele?.itemCode?.value !== '') {
               if (!ele?.invoiceitemid) {
      currentMaxInvoiceItemId += 1;
      ele.invoiceitemid = currentMaxInvoiceItemId;
    }
          const lineItem = {
            hsnsaccode: String(ele?.HSN?.value === '' ? 0 : ele?.HSN?.value),
            invoicelineitemtype: 'ITEM',
            itemamount: Number(ele.amount),
            itemdiscount: Number(ele.dicount),
            itemid: Number(ele?.name?.value),
            itemrate: Number(ele.rate),
            taxability: data?.taxability?.value,
            lineitemnumber: index + 1,
            netamount: Number(ele.netAmount),
            quantity: Number(ele.qty),
            pricetype: ele?.priceType?.label,
            pricetypeid: ele.priceType?.value,
            unittypecd: ele.units,
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            lotid: 0,
            companybranchid: 0,
            manualdiscount: ele?.manualDiscount === true ? 1 : 0,
              manualcess: Number(ele?.manualCess),
                 
            itemtype:String(ele.itemType),
            invoicedate:Math.floor(new Date(data?.invoiceDate).getTime() / 1000),
            manualgst:Number(ele?.manualGSTFlag),
             discounttype:String(ele?.discountType),
            discountrate:Number(ele.discountRate),
          };
          invLineItemArr.push(lineItem);

          const gstData = {
            cessamount: Number(ele.GSTCess),
            gstamount: Number(ele.IGST),
            gstrate: Number(ele.GSTRate),
            gsttypecd: '',
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
               
                 cessrate:Number(ele.cessRate),
                  cesstype:String(ele?.cessType),
          };
          invLineGstArr.push(gstData);
        }
      });

      Math.floor(new Date().getTime() / 1000);
      const exp = Math.floor(new Date().getTime() / 1000);
      const idsInArray2 = new Set(itemsRows.map((item) => item.attachmentid));

      let arratt = [];
      const updatedArray1 = currentDouments.map((item) => {
        let arr;
        if (!idsInArray2.has(item.attachmentid) && typeof item.attachmentid !== 'string') {
          arr = { ...item, expiredtimestamp: exp };
          arratt.push(arr);
        } else {
          arr = itemsRows.find((att) => att.attachmentid === item.attachmentid);
          arratt.push(arr);
        }
      });

      const additionalItems = itemsRows.filter((item2) => !currentDouments.some((item1) => item1.attachmentid == item2.attachmentid));

      const finalArray = [...arratt, ...additionalItems];
      const attachedArr = finalArray.map((ele) => ({
        attachmentid: typeof ele.attachmentid === 'string' ? 0 : ele.attachmentid,
        invoiceid: invoiceEntry?.invoiceid,
        documentname: ele.documentname,
        attachmentname: ele.imagename,
        attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename.replace('${id}', invoiceEntry?.invoiceid)}`,
        type: ele?.type,
        companybranchid: 0,
        expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
      }));
      invTransArr.map((ele, ind) => {
        let obj = {
          transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
          accountid: Number(ele.accID),
          creditamount: Number(ele.creditAmt),
          debitamount: Number(ele.debitAmt),
          comments: data.remarks || '',
          transactionid: Number(invoiceEntry?.relatedinvoicetransactiondetails?.[0]?.transactionid) || 0, // Int
          enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000), // Int
          cancelflag: 0, // Int
        };

        invTransactionArray.push(obj);
      });

      if (attachedArr?.length > 0) {
        let responses = itemsRows.map((element) => {
          if (element.file) {
            return uploadToServer(element.file, element.imagename.replace('${id}', invoiceEntry?.invoiceid), element.type);
          }
        });
      }
      await Promise.all(attachedArr);
      const tcsData = {
        adjustmentamount: Number(data.adjustments),

        expiredtimestamp: 0,
        gstcesstotal: Number(totGSTCess),
        ineligibletcflag: data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag,
        invoiceid: invoiceEntry?.invoiceid,
        reversechargeflag: data.reverseChargeFlag,
        tcsamount: Number(data.tcsAmount),
        tcsapplicablecd: data.tcsFlag === '' ? 0 : data.tcsFlag,
        tcssection: data.tcsOptions,
        totaltaxableamount: Number(totTaxAmt),
        tcspercentage: Number(data.tcsPercent),
        tcsmanual: data.manualTcsFlag,
        companybranchid: 0,
      };

      variables = {
        createInvoiceMasterInput: masterData,
        createInvoiceLineItemsInput: invLineItemArr,
        createInvoiceLineGSTInput: invLineGstArr,
        createInvoiceAttachmentInput: attachedArr,
        createInvoiceTCSDetailsInput: [tcsData],
        createTransactionWithSpecificTimeInput: {
          transactionmaster: [],
          transactiondetails: invTransactionArray,
          transactionattachment: [],
          transactiontdsdetails: [],
          transactionrelation: [],
          mode: 0,
          transactiontcsdetails: [],
        },
      };

      const response = await API.graphql(graphqlOperation(createPosBatch, variables));

      // updatePaymentDetails(response?.data?.createInvoiceMaster?.invoiceid);
      if (response.data?.createInvoiceMaster?.statuscode === 'Error') {
        showWarningSnackbar(response?.data?.createInvoiceMaster.statusmessage);
      } else {
        setBackdropOpen(false);
        showSuccessSnackbar('Pos updated successfully');
        createPdf({
          path: url,
          type: 'pos',
          invoiceids: invoiceEntry?.invoiceid,
        });

        navigate('/allpos?active=pos', { force: true });
      }
    } catch (error) {
      setBackdropOpen(false);
      showErrorSnackbar('Some thing went wrong.Please  try again');
      console.log('error', error);
    } finally {
      dispatch(dispatch(setNavigationBlocked(false)));
    }
  }

  async function updatePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      let linkedArr = [];
      const comments = data.remarks.split('\n');
      if (data.paymentType !== 'Credit') {
        if (paymentTransID !== '') {
          const transMaster = {
            transactionid: paymentTransID,
            bankreferencenumber: data.bankReferenceNo,
            entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
            comments: comments?.join('**'),
            vouchernumber: data.transactionVoucher,
            serialnumber: data.transactionSeries.value,
            transactiontypecd: data.paymentType == 'Cash' ? 'CashReceipt' : data.paymentType == 'Bank' ? 'BankReceipt' : 'Credit',
            cancelflag: 0,
          };

          paymentTransArr.map((ele, index) => {
            const paymentTransDetails = {
              accountid: ele.accID,
              comments: comments?.join('**'),
              creditamount: Number(ele.creditAmt),
              debitamount: Number(ele.debitAmt),
              entryordernumber: index + 1,
              transactionid: paymentTransID,
              transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
              enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
              cancelflag: 0,
            };
            tranSDetailsArr.push(paymentTransDetails);
          });

          const linkCurrentPayment = {
            linkedamount: Number(data.receivedAmount),
            transactiontypecd: 'PosInvoice',
            isdirect: 1,
            objectattribute: data.voucherNumber,
            objectid: invoiceEntry?.invoiceid,
            objecttype: data.paymentType,
            transactionid: paymentTransID,
            accountid: partyAccountID === '' ? 0 : partyAccountID,
            paymentvouchernumber: data?.transactionVoucher,
            expiredtimestamp: 0,
          };
          linkedArr.push(linkCurrentPayment);
          linkedTransArr.map(async (ele) => {
            let linkTransData = {
              linkedamount: Number(ele.linkedamount),
              transactiontypecd: 'PosInvoice',
              isdirect: 0,
              objectattribute: data?.voucherNumber,
              objectid: invID,
              objecttype: ele.transactiontypecd,
              transactionid: ele.transactionid,
              accountid: partyAccountID === '' ? 0 : partyAccountID,
              paymentvouchernumber: data?.transactionVoucher,
              expiredtimestamp: 0,
            };
            linkedArr.push(linkTransData);
          });

          const result = await API.graphql(
            graphqlOperation(createTransactionWithSpecificTime, {
              transactionmaster: JSON.stringify([transMaster]),
              transactiondetails: JSON.stringify(tranSDetailsArr),
              transactionattachment: JSON.stringify([]),
              transactiontdsdetails: JSON.stringify([]),
              transactionrelation: JSON.stringify(linkedArr),
              mode: 0,
              transactiontcsdetails: JSON.stringify([]),
            })
          );
          let url = path + `Invoices/Receipt/Ledgerx_Receipt_${data.transactionVoucher}.pdf`;
          await createPdf({
            path: url,
            type: 'receipt',
            transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
          });
        } else {
          savePaymentDetails(invID);
        }
      } else {
        if (paymentTransID !== '' && data?.paymentDeletionFlag === true) {
          const deleteTransMaster = await API.graphql(
            graphqlOperation(deleteTransactionMaster, {
              transactionid: paymentTransID,
            })
          );
        }
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  const [errorArr, setErrorArr] = useState({});
  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }

      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);

        element?.focus();
      }
    }
  }, [errorArr]);
  useEffect(() => {
    if (tableErrArr.length > 0) {
      let element = document?.getElementById(tableErrArr[0]);

      element?.focus();
    }
  }, [tableErrArr]);
  useEffect(() => {
    let id = 'partyContactNumber';
    if (params?.id) {
      getInvoiceMasterData(params?.id);
      setViewMode(params?.view);
    } else {
      setBackdropOpen(false);
    }
    if(!params?.id){
    let element = document?.getElementById(id);
    element?.focus();
    }
  }, []);


  const [promptInvoiceSetting, setpromptInvoiceSetting] = useState(false);
  const { updated } = location.state || {};

  async function print(htmlOnly) {
    let html = await PosPrint({
      data,
      items,
      netAmountToPay,
      totGstCess: totGSTCess,
      totDiscount: totDiscount,
      totGST,
      totNetAmount: netAmountToPay,
      registrationType,
      totAmount: totAmt,
      companyDetails: companyData,
      InvoiceSettings,
      companyState: companyState,
      additionalDiscount: data.adjustments,
      tcsAmount: data.tcsAmount,
      totTaxAmt,
      totNetAmt,

    });
    if (htmlOnly) {
      return html;
    } else {
      printJS({
        printable: html,
        type: 'raw-html',
        documentTitle: '',
      });
    }
  }
  useEffect(() => {
    if (!InvoiceFetching) {
      getLastSalesInvoice();
    }
  }, [InvoiceFetching, getCompany, voucherFlag,data?.seriesVouchers?.value,savedPostingDate]);
   useEffect(()=>{
      if(currentPostingDate){
      setSavedPostingDate(currentPostingDate);
      }
  
    },[currentPostingDate]);

  const MailIt = async (InvoiceName) => {
    let html = await print(true);

    try {
      const option = {
        method: 'POST',
        url: 'https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws/',
        data: JSON.stringify({ html, InvoiceName }),
      };
      return await axios(option);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  };
  const callBackNavigate = () => (isVoucher ? isVoucher(false) : navigate('/allpos'));

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const ids = [
    'partyCreationModal',
    'addItemModal',
    'deleteCategory',
    'AddLedger',
    'AddHSNModal',
    'AddTdsTcsOptions',
    'BillingAddressModal',
    'DeliveryAddressModal',
    'SettingsModal',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useSaveShortcut(
    params?.id && params?.view !== true
      ? () => {
          if (!anyElementExists()) saveEditChanges();
        }
      : params?.view !== true
      ? () => {
          if (!anyElementExists()) saveChanges({ new: false });
        }
      : undefined
  );
 function checkDateMyPostDate(lastInvoiceDate, savedPostingDate) {
 
   let valid = false;
   const fyStart = userPreferece?.financialYear?.startdate;
   if (!fyStart) return;
   const fyStartMoment =
     typeof fyStart === 'number'
       ? moment.unix(fyStart).startOf('day')
       : moment(fyStart, ['YYYY-MM-DD', moment.ISO_8601], true).startOf('day');
 
   const lastInvoiceMoment =
     typeof lastInvoiceDate === 'number'
       ? moment.unix(lastInvoiceDate).startOf('day')
       : moment(lastInvoiceDate, ['YYYY-MM-DD', moment.ISO_8601], true).startOf('day');
 
   const savedPostingMoment =
     typeof savedPostingDate === 'number'
       ? moment.unix(savedPostingDate).startOf('day')
       : moment(savedPostingDate, ['YYYY-MM-DD', moment.ISO_8601], true).startOf('day');
   const computedMinDate = lastInvoiceMoment.isValid()
     ? lastInvoiceMoment
     : fyStartMoment;
 
   if (!computedMinDate.isValid() || !savedPostingMoment.isValid()) return;
   if (savedPostingMoment.isBefore(computedMinDate, 'day')) {
    //  showWarningSnackbar(
    //    "'My Posting Date' does not apply to this form because it is earlier than the last invoiced date."
    //  );
     valid = false;
   } else {
     const formattedDate = savedPostingMoment.format('YYYY-MM-DD');
     setInitialState((prev) => ({
       ...prev,
       invoiceDate: formattedDate,
     }));
     setData((prev) => ({
       ...prev,
       invoiceDate: formattedDate,
     }));
     valid = true;
   }
 
   return valid;
 }
  return (
    <Box className="PageHeight">
      {viewMode === true && invoiceEntry?.cancelflag ? (
        <>
          <Box
            sx={{
              position: 'sticky',
              top: '10px',
              borderRadius: '8px',
              marginBottom: '0px',
              padding: { xs: '10px 0px', sm: '10px 10px' },
              transition: 'all 1s ease-in-out',
            }}
          >
            <Alert
              variant="standard"
              sx={{
                color: invoiceEntry?.cancelflag === 0 ? '' : 'red',
                boxShadow: 'none',
                width: 450,
              }}
              severity="error"
            >
              {invoiceEntry?.cancelflag === 1 ? 'POS cancelled. No further updates can be made.' : null}
            </Alert>
          </Box>
          <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '10' }}>
            <CancelUI />
          </Box>
        </>
      ) : null}

      <Box
        className='darkDisabledInputs'
        sx={{
          opacity: viewMode === true && invoiceEntry?.cancelflag ? '0.5' : '1',
          cursor: viewMode === true && invoiceEntry?.cancelflag ? 'no-drop' : 'default',
        }}
      >
        <Box
          sx={{
            borderRadius: '8px',
            // marginBottom: "10px",
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            padding: { xs: '10px 0px', sm: '0px 0px' },
            ':hover': {
              boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            },
            transition: 'all 1s ease-in-out',
          }}
        >
          <InvoicePosBasicDetails
            todayDate={todayDate}
            moment={moment}
            invoiceLabels={{
              partyName: 'Customer Name',
              gstINName: 'Customer GSTIN',
              seriesName: 'Invoice Series Name',
              // voucherName: 'Invoice Number',
               voucherName:Number(generalSettingsFlag)===-1?([2,3,5]?.includes(data?.taxability?.value)?'BOS Invoice No':'Tax Invoice No'):(data?.seriesVouchers?.serialflag===1?'BOS Invoice No':'Tax Invoice No'),
              voucherValue: 'voucherNumber',
              dateName: 'Invoice Date',
              seriesValue: 'seriesVouchers',
              voucherType: 'PosInvoice',
              orderNumberName: 'Customer Order Number',
              voucherModalName: 'Pos Invoice Number Settings',
              orderDateName: 'Customer Order Date',
            }}
            partyTypeCD={'CUSTOMER'}
            params={params}
            Type="Pos"
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            // borderRadius: "12px",
            overflow: 'hidden',
            mt: 3,
            // marginBottom: "10px",

            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '0px 5px',
            },
            '.MuiTableCell-head': {
              borderBottom: '0px',
              fontWeight: 'bold',
            },
          }}
        >
          <Box sx={{ m: 2, marginTop: '0px', marginBottom: '0px', marginLeft: '0px' }}>
            <EntryTable
              Type="Pos"
              invoiceLabels={{
                partyName: 'Customer Name',
                gstINName: 'Customer GSTIN',
                seriesName: 'Invoice Series Name',
                voucherName: 'Invoice Number',
                voucherValue: 'voucherNumber',
                dateName: 'Invoice Date',
                seriesValue: 'seriesVouchers',
                voucherType: 'PosInvoice',
                orderNumberName: 'Customer Order Number',
                voucherModalName: 'Pos Invoice Number Settings',
                orderDateName: 'Customer Order Date',
              }}
              labelNamesOfTcs={{
                tdsOrTcsType: '2',
                amountName: 'Invoice Amount',
                tcsOrTdsName: 'Add TCS if any',
                tcsOrTdsLabel: 'TCS Section',
                tcsOrTdsAmountLabel: 'TCS (%)',
                amountAfterLabel: 'Amount(After TCS)',
              }}
              labelNamesOfTds={{
                tdsOrTcsType: '1',
                amountName: 'Invoice Amount',
                tcsOrTdsName: 'Add TDS if any',
                tcsOrTdsLabel: 'TDS Section',
                tcsOrTdsAmountLabel: 'TDS (%)',
                amountAfterLabel: 'Amount(After TDS)',
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            width: '100%',
            // borderRadius: "12px",
            // borderTopLeftRadius: "0px",
            overflow: { xs: 'scroll', lg: 'hidden' },
            // marginBottom: "10px",
            border: { xs: 'none', lg: '1px solid gray' },
            borderColor: 'input.label',
            mt: 3,
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '4px 10px',
            },
            '.MuiTableCell-head': {
              backgroundColor: 'background.tablebg',
              padding: '10px 8px',
              borderBottom: '0px',
              fontSize: '13px',
              fontWeight: 'bold',
            },
            // backgroundColor:"red"
          }}
        >
          <Box
            className="custom-scrollbar"
            sx={{
              m: 1,
              marginTop: '0px',
              marginBottom: '0px',
              marginLeft: '0px',
              display: 'flex',
              // flexWrap: { xs: 'wrap', md: 'wrap' },
              flexDirection: { xs: 'column', lg: 'row' },
              overflow:"scroll"
              // height:350,
            }}
          >
            <HsnandJournalTab Type="Pos" />
            <Box
              sx={{
                flex: { xs: 1, lg: 0.5 },
                // mt: "3px",
                // border: "1px solid #C9C9C9",
                // borderColor: "input.label",
                height: '90%',
                // p: "5px",
                overflowX: 'none',
                paddingBottom: '20px',
                border: { xs: 'solid 1px gray', lg: 'none' },
                borderLeft: { lg: '1px solid gray' },
                marginTop: '10px',

                // height:"90%"
              }}
            >
              <TotalAmountLabels
                labelNamesOfTcs={{
                  tdsOrTcsType: '2',
                  amountName: 'Invoice Amount',
                  tcsOrTdsName: 'Add TCS if any',
                  tcsOrTdsLabel: 'TCS Section',
                  tcsOrTdsAmountLabel: 'TCS (%)',
                  amountAfterLabel: 'Amount(After TCS)',
                }}
                labelNamesOfTds={{
                  tdsOrTcsType: '1',
                  amountName: 'Invoice Amount',
                  tcsOrTdsName: 'Add TDS if any',
                  tcsOrTdsLabel: 'TDS Section',
                  tcsOrTdsAmountLabel: 'TDS (%)',
                  amountAfterLabel: 'Amount(After TDS)',
                }}
                Type="Pos"
                Enable_ItemWiseEntry={Enable_ItemWiseEntry}
                partyType={'CUSTOMER'}
              />
              <PosPaymentDetails
                Enable_CreditPeriod={Enable_CreditPeriod}
                todayDate={todayDate}
                moment={moment}
                paymentType={'Receipt Details'}
                paymentLabels={{
                  seriesName: 'Receipt Series Name',
                  voucherName: data.paymentType == 'Cash' ? 'Cash Receipt Number' : 'Bank Receipt Number',
                  voucherValue: 'transactionVoucher',
                  seriesValue: 'transactionSeries',
                  voucherType: 'Receipt',
                  accLabel: 'Received To Account (Dr)',
                  accNames: 'Received To Account',
                  amountName: 'Received Amount',
                  dueDateName: 'Invoice Due Date',
                  voucherModalName: 'Receipt Number Settings',
                }}
                Type="Pos"
                params={params}
              />
            </Box>
          </Box>
        </Box>
        {/* <Box
        sx={{
          marginBottom: "10px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <PaymentDetails
          Enable_CreditPeriod={Enable_CreditPeriod}
          todayDate={todayDate}
          moment={moment}
          paymentType={"Receipt Details"}
          paymentLabels={{
            seriesName: "Receipt Series Name",
            voucherName:
              data.paymentType == "Cash"
                ? "Cash Receipt Number"
                : "Bank Receipt Number",
            voucherValue: "transactionVoucher",
            seriesValue: "transactionSeries",
            voucherType: "Receipt",
            accLabel: "Received To Account (Dr)",
            accNames: "Received To Account",
            amountName: "Received Amount",
            dueDateName: "Invoice Due Date",
            voucherModalName: "Receipt Number Settings",
          }}
          Type="Pos"
          params={params}
        />
      </Box> */}
        <Grid lg={12} sx={{ marginTop: '16px', marginBottom: '0px' }}>
          <Box
            sx={{
              padding: { xs: '10px 0px', sm: '0px 00px' },

              display: 'flex',
              gap: '20px',
              flexDirection: { xs: 'column', md: 'column', lg: 'row' },
            }}
          >
            <Grid
              item
              container
              lg={3}
              xs={12}
              md={12}
              sx={{
                // padding: "0px 10px",
                display: 'flex',
                gap: '20px',
                flexDirection: 'column',
                '.MuiPaper-root': {
                  boxShadow: 'none',
                },
              }}
            >
              <Description labelName="Invoice Description" Type="Pos" />
            </Grid>
            {/* <Grid item container lg={9} xs={12} md={12}> */}
            <MultiFileAttachment Type="Pos" />
            {/* </Grid> */}
          </Box>
        </Grid>
      </Box>

      {/* {(viewMode == true ? invoiceEntry.cancelflag === 0 : true) ? ( */}
      <DraggableAction
        actionType={params?.id && params?.view !== true ? 'edit' : invoiceEntry?.cancelflag === 1 ? 'cancelled' : 'save'}
        from={'POS Invoice'}
        onExit={() => {
          navigate('/allpos');
        }}
        onSave={
          params?.id && params?.view !== true
            ? () => {
                saveEditChanges();
              }
            : params?.view !== true
            ? () => saveChanges({ new: false })
            : null
        }
        onEnableEdit={() => {
          navigate('/editpos', {
            state: { id: invoiceEntry?.invoiceid },
          });
        }}
        onPrint={params?.view == true || params?.id ? () => fetchAndPrintPDF(uri) : null}
        onCancel={
          params?.view == true || params?.id
            ? () => {
                setCancelModalStatus(true);
                setItemData({
                  id: invoiceEntry?.invoiceid,
                  nav: '/allpos',
                  todo: 'cancel',
                  linked: paymentTransID !== '',

                  from: 'POS Invoice',
                });
              }
            : null
        }
        onDelete={
          params?.view == true || params?.id
            ? () => {
                setDeleteModalStatus(true);
                setItemData({
                  id: invoiceEntry?.invoiceid,
                  nav: '/allpos',
                  todo: 'delete',
                  linked: paymentTransID !== '',
                  // fn: () => deletePurchaseInvoice(invoiceEntry?.PurchaseID),
                  from: 'POS Invoice',
                });
              }
            : null
        }
        onPreview={
          // params?.view == true || Number.isNaN(params?.id)
          //   ? () => {
          //       setPreviewSalesTaxableModal(true);
          //     }
          //   : null
          () => { setPreviewSalesTaxableModal(true)}
        }
        onSaveNew={params?.view !== true ? () => saveChanges({ new: true }) : null}
        onReset={
          params?.view !== true
            ? () => {
                setData(initialState);
                if (params?.id) {
                  setItems(initItemTableDta.length > 0 ? initItemTableDta : [newItemObj]);
                  setItemsRows(initialAttachments);
                  setSelected([]); // Clear email selection
                } else {
                  // setData((prevData) => ({
                  //   ...resetData, // Reset all fields
                  //   transactionVoucher: prevData?.transactionVoucher,
                  //   voucherNumber: prevData?.voucherNumber, // Preserve voucherNumber
                  //   invoiceDate: prevData?.invoiceDate,
                  //   seriesVouchers: prevData?.seriesVouchers,
                  //   transactionSeries: prevData?.transactionSeries,
                  // }));
                  setData(initialState);
                  setNonItems([resetNonItems]);
                  setItems([resetItems]);
                  setItemValid(true);
                  setItemsRows([]);
                  setSelected([]); // Clear email selection
                }
              }
            : null
        }
      />
      {/* ) : null} */}
      {cancelModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={cancelModalStatus}
          setOpen={setCancelModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          actionType={'Cancel'}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          invTransArr={invTransArr}
          paymentTransArr={paymentTransArr}
          netAmountToPay={netAmountToPay}
          companyState={companyState}
          Type={'Pos'}
          path={url}
        />
      ) : null}
      {deleteModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={deleteModalStatus}
          setOpen={setDeleteModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          actionType={'Delete'}
          Type={'Pos'}
          path={url}
        />
      ) : null}
      <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="allpos" />
      <Loader open={backdropOpen} />
      <PreviewSalesTaxable open={previewSalesTaxableModal} setOpen={setPreviewSalesTaxableModal} getHtml={print} />
      <PromptInvoiceSettings
        open={promptInvoiceSetting}
        onClick={() => {
          navigate('/invoiceSettings', {
            state: { title: 'newpos' },
          });
        }}
        onClose={() => setpromptInvoiceSetting(false)}
      />
      {modalOpen && <ConfirmExit open={modalOpen} setOpen={setModalOpen} reNavigate={reNavigate} />}
      {shareOpen && (
        <ShareModal
          open={shareOpen}
          emailData={{
            selectedRow: selected?.map((inv) => ({
              id: Number(inv.invoiceid),
              recipientId: Number(inv.PartyID),
              email: inv.Email,
              name: inv.PartyDisplayName,
              invoiceNumber: inv.voucherNumber,
            })),
            type: 'PosInvoice',
          }}
          progress={progress}
          onClose={callBackNavigate}
        />
      )}
    </Box>
  );
}

export default NewPOSPrime;
